import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    products: [],
    carts: [],
    transactions: [],
    loginStatus: false,
    name: ""
  },
  mutations: {
    FETCH_PRODUCTS(state, payload) {
      state.products = payload
    },
    FETCH_CARTS(state, payload) {
      state.carts = payload
    },
    FETCH_TRANSACTIONS(state, payload) {
      state.transactions = payload
    },
    LOGIN(state) {
      state.loginStatus = true
      state.name = localStorage.name
    },
    LOGOUT(state) {
      state.loginStatus = false,
      state.email = ""
    }
  },
  actions: {
    fetchProducts({ commit }) {
      axios({
        method: 'get',
        url: 'https://dry-savannah-57278.herokuapp.com/products/'
      })
        .then(({ data }) => {
          commit("FETCH_PRODUCTS", data.products);
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchCarts({ commit }) {
      axios({
        method: 'get',
        url: 'https://dry-savannah-57278.herokuapp.com/carts/',
        headers: {
          token: localStorage.token
        }
      })
        .then(({ data }) => {
          commit("FETCH_CARTS", data.productsOnCart);
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchTransactions({ commit }) {
      axios({
        method: 'get',
        url: 'https://dry-savannah-57278.herokuapp.com/transactions/',
        headers: {
          token: localStorage.token
        }
      })
        .then(({ data }) => {
          commit("FETCH_TRANSACTIONS", data);
        })
        .catch(err => {
          console.log(err)
        })
    },
    logout({ commit }) {
      localStorage.clear();
      commit('LOGOUT');
    },
    login({ commit }) {
      commit('LOGIN');
    },
    checkLogin({ commit }) {
      if (localStorage.token) {
        commit('LOGIN');
      } else {
        commit('LOGOUT');
      }
    },
  },
  modules: {
  }
})
